module.exports = __webpack_public_path__ + "assets/img/img174.2d736792.png";